module.exports = __webpack_public_path__ + "b36a16a9238813e359ef2bce70d446b6.png";